import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import PropTypes from 'prop-types';
export var registerEvents = function registerEvents(events, props, instance) {
  var eventsAvailable = Object.keys(events);
  var listeners = Object.keys(props).filter(function (key) {
    return eventsAvailable.indexOf(key) !== -1;
  }).map(function (name) {
    return instance.addListener(events[name], function (event) {
      props[name]({
        event: event,
        marker: instance
      });
    });
  });
  return function () {
    listeners.forEach(function (listener) {
      return listener.remove();
    });
  };
};
export var createListenersPropTypes = function createListenersPropTypes(eventTypes) {
  return Object.keys(eventTypes).reduce(function (acc, name) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, PropTypes.func));
  }, {});
};
export var createFilterProps = function createFilterProps(excludes) {
  return function (props) {
    return Object.keys(props).filter(function (name) {
      return excludes.indexOf(name) === -1;
    }).reduce(function (acc, name) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, props[name]));
    }, {});
  };
};